module.exports = __webpack_public_path__ + "img/previous_exam_papers_active.b762cacd.svg";